import React, { PureComponent } from 'react';

import {
    DialogAsMethodRederer,
    DialogAsMethodRedererProps,
} from 'reactComponents/DialogAsMethodRederer/DialogAsMethodRederer';
import {
    PhoneVerification,
    PhoneVerificationProps,
} from 'reactComponents/PhoneVerification/PhoneVerification';

type OwnProps = Omit<PhoneVerificationProps, 'likeDialog'>;

type Props = OwnProps & DialogAsMethodRedererProps;
class _PhoneVerificationDialog extends PureComponent<Props> {
    render() {
        const {
            onConfirmed,
            onClose,
            isOpened,
            dialogDescription,
            dialogHeader,
        } = this.props;

        return (
            <PhoneVerification
                likeDialog
                dialogDescription={dialogDescription}
                dialogHeader={dialogHeader}
                onConfirmed={onConfirmed}
                isOpened={isOpened}
                onClose={onClose}
            />
        );
    }
}

export const PhoneVerificationDialog = DialogAsMethodRederer.makeDialogRenderer<
    OwnProps
>(_PhoneVerificationDialog);
